import { render } from "./Periodical.vue?vue&type=template&id=2d742076&scoped=true"
import script from "./Periodical.vue?vue&type=script&lang=js"
export * from "./Periodical.vue?vue&type=script&lang=js"

import "./Periodical.vue?vue&type=style&index=0&id=2d742076&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d742076"]])

export default __exports__